export const LOGIN_AUTH_TOKEN_KEY = 'mdLoginToken';
export const LOGIN_AUTH_REFRESH_TOKEN_KEY = 'mdRefreshToken';

export const AIDT_LOGIN_AUTH_PARTNER_ID = 'aidtPartnerId'; //
export const AIDT_LOGIN_AUTH_PARTNER_KEYWORD = 'aidtPartnerKeyword'; //

export const AIDT_ACCESS_ID = 'aidtAccessId'; // AIDT 포탈 로그인 사용자 ID
export const AIDT_ACCESS_TOKEN = 'aidtAccessToken'; // AIDT 포탈 인증 토큰
export const AIDT_SSO_RETURN_TOKEN = 'aidtPmiSsoReturn';
export const AIDT_API_DOMAIN = 'aidtApiDomain';
export const AIDT_SECURENONCE = 'aidtSecurenonce';
export const AIDT_USER_ID = 'aidtUserId'; // AIDT 포탈 사용자 ID (개인 식별코드)
export const AIDT_KEY_ID = 'aidtKeyId';
export const AIDT_LECTURE_CODE = 'aidtLectureCode';
export const AIDT_NEED_SESSION_INVALIDATE = 'aidtNeedSessionInvalidate';
export const AIDT_STUDENT_LOGIN_GROUP_ID = 'aidtStudentLoginGroupId';
export const IS_AIDT_LOGIN = 'isAidtLogin';
export const AIDT_USER_TYPE = 'aidtUserType'; // S 학생, T 선생님, P 학부모

export type AidtUserType = 'S' | 'T' | 'P';
